/* GOWin® Store — sincronización robusta del contador del carrito */
(() => {
  'use strict';

  if (window.GowinCartCountSyncV1) return;
  window.GowinCartCountSyncV1 = true;

  let sectionRequest = null;
  let cartRequest = null;

  const cartIcon = () => document.getElementById('cart-icon-bubble');

  const normalizeCount = (value) => {
    const count = Number(value);
    return Number.isFinite(count) && count >= 0 ? Math.trunc(count) : null;
  };

  const syncVisibleCount = (value) => {
    const count = normalizeCount(value);
    const icon = cartIcon();
    if (count === null || !icon) return false;

    const bubble = icon.querySelector('.cart-count-bubble');

    if (count === 0) {
      bubble?.remove();
      icon.dataset.gowinCartCount = '0';
      return true;
    }

    if (!bubble) return false;

    const visible = bubble.querySelector('span[aria-hidden="true"]');
    if (visible) visible.textContent = count < 100 ? String(count) : '';

    icon.dataset.gowinCartCount = String(count);
    return true;
  };

  const refreshIconSection = () => {
    const icon = cartIcon();
    if (!icon || !window.routes?.cart_url) return Promise.resolve(false);
    if (sectionRequest) return sectionRequest;

    const separator = routes.cart_url.includes('?') ? '&' : '?';
    const url = `${routes.cart_url}${separator}section_id=cart-icon-bubble`;

    sectionRequest = fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart-icon-bubble request failed');
        return response.text();
      })
      .then((html) => {
        const current = cartIcon();
        const markup = String(html || '').trim();
        if (!current || !markup) return false;
        current.innerHTML = markup;
        return true;
      })
      .catch(() => false)
      .finally(() => {
        sectionRequest = null;
      });

    return sectionRequest;
  };

  const syncFromState = (state) => {
    const count = normalizeCount(state?.item_count);
    if (count === null) return false;

    const hadMatchingBubble = syncVisibleCount(count);

    // Al quedar vacío hay que sustituir también el SVG por el estado vacío.
    // Si venimos de carrito vacío y se agrega algo, reconstruimos la burbuja completa.
    if (count === 0 || !hadMatchingBubble) refreshIconSection();
    return true;
  };

  const fetchCartState = () => {
    if (!window.routes?.cart_url) return Promise.resolve(null);
    if (cartRequest) return cartRequest;

    const base = String(routes.cart_url).replace(/\/$/, '');
    cartRequest = fetch(`${base}.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart.js request failed');
        return response.json();
      })
      .then((state) => {
        syncFromState(state);
        return state;
      })
      .catch(() => null)
      .finally(() => {
        cartRequest = null;
      });

    return cartRequest;
  };

  const stateFromDomEvent = (event) =>
    event?.detail?.cartData || event?.detail?.cart || event?.detail?.state || null;

  const installPubSub = () => {
    const subscribeFn = typeof subscribe === 'function' ? subscribe : window.subscribe;
    const events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;

    if (typeof subscribeFn !== 'function' || !events?.cartUpdate) return false;
    if (window.GowinCartCountPubSubInstalled) return true;

    window.GowinCartCountPubSubInstalled = true;
    subscribeFn(events.cartUpdate, (event) => {
      if (!syncFromState(event?.cartData || event?.cart || null)) fetchCartState();
    });
    return true;
  };

  const install = () => {
    installPubSub();
    fetchCartState();
  };

  document.addEventListener('cart:updated', (event) => {
    if (!syncFromState(stateFromDomEvent(event))) fetchCartState();
  });

  document.addEventListener('cart:refresh', (event) => {
    if (!syncFromState(stateFromDomEvent(event))) fetchCartState();
  });

  document.addEventListener('shopify:section:load', install);
  window.addEventListener('pageshow', fetchCartState);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', install, { once: true })
    : install();
})();
